import React from "react";
import JsonformTableRender from "../../Misc/JsonformTableRender";
export default function TrackerSummaryPrint(props) {
  let tracker = props.tracker || {};
  let item = props.item || {};
  let data = item.data || {};
  let form = item.form || {};

  let date = new Date(item.date) || {};
  let datestart = tracker.datestart
    ? new Date(tracker.datestart).toLocaleString()
    : null;
  let datestop = tracker.datestop
    ? new Date(tracker.datestop).toLocaleString()
    : null;

  return (
    <>
      <table className="table">
        <tbody>
          <tr>
            <td colSpan={2}>
              {item.shipname} : {tracker.label}
            </td>
          </tr>
          <tr>
            <td colSpan={2}>
              {date.toLocaleDateString()} {item.ownername}
            </td>
          </tr>
          <tr>
            <td width="50%">{tracker.departurename}</td>
            <td>{tracker.arrivalname}</td>
          </tr>
          <tr>
            <td width="50%">{datestart || " "}</td>
            <td>{datestop || " "}</td>
          </tr>
        </tbody>
      </table>
      <JsonformTableRender form={form} data={data} />
    </>
  );
}
